export default "__VITE_ASSET__3abb06c2__"